 export const UPDATEFORM='UPDATEFORM'
 export const RESETFORM='RESETFORM'

interface updateFormAction{
    type: typeof UPDATEFORM;
    payload:{field:string;value:string};
}

interface resetFormAction{
    type:typeof RESETFORM
}

export type formActionTypes = updateFormAction | resetFormAction;